import React from "react";
import DropdownContainer from "../../../../../../common-deprecated/components/dropdown/DropdownContainer";
import { IconWrapper } from "../../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";
import Icon from "../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import * as Type from "../../../../../../common-deprecated/styles/v2/lexus/globals/Type";
import * as Styles from "./styles/FilterDropdownStyles";
import useFilterDropDown from "../../../../../../shared-logic/features/filters/hooks/useFilterDropDown";

type FilterDropdownType = {
    onClick: () => void;
    show: boolean;
    title: string;
    children: React.ReactNode;
};

const FilterDropdown = (props: FilterDropdownType): JSX.Element => {
    const { show, onClick, title, children } = props;
    const { propagatedShow, renderDropdownContainer } = useFilterDropDown(show);

    return (
        <Styles.ListItem role="listitem">
            <Styles.Wrapper isActive={propagatedShow}>
                <Styles.Header onClick={onClick} show={propagatedShow} role="button">
                    <Type.Text headingType="delta">{title}</Type.Text>
                    <IconWrapper>
                        <Icon variant="plus" />
                    </IconWrapper>
                </Styles.Header>
                {renderDropdownContainer && (
                    <DropdownContainer show={propagatedShow} scrollIntoView>
                        <Styles.DropdownContent show={propagatedShow}>{children}</Styles.DropdownContent>
                    </DropdownContainer>
                )}
            </Styles.Wrapper>
        </Styles.ListItem>
    );
};

export default FilterDropdown;
